import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { VetDetailsPropTypes } from '../../../propTypes/vetDetails';
import { GetAddressParts } from '../../../helpers/vetHelpers';
import { HighlightText } from '../../../helpers/formattingHelper';

export const VetNameAndAddress = ({ vetDetail, highlightText, isFullDetailView }) => {
  const { serviceProvider, ServiceProviderName, ServiceProviderContactNumber } = vetDetail;

  const addressMarkup = useMemo(() => {
    const addressPieces = GetAddressParts({ vetDetail });

    if (isFullDetailView) {
      return (
        <span className="fullContactDetails">
          <span>{addressPieces[0]}</span>
          <span>{addressPieces.slice(1).join(', ')}</span>
          <span>{ServiceProviderContactNumber}</span>
        </span>
      );
    }

    return (
      <span className="vetAddress">
        {HighlightText({ textString: addressPieces.join(', '), highlightString: highlightText })}
      </span>
    );
  }, [ServiceProviderContactNumber, highlightText, isFullDetailView, vetDetail]);

  const nameMarkup = useMemo(() => {
    return (
      <strong className="vetName">
        {HighlightText({ textString: serviceProvider || ServiceProviderName, highlightString: highlightText })}
      </strong>
    );
  }, [serviceProvider, ServiceProviderName, highlightText]);

  return (
    <span className="vetNameAndAddress">
      {nameMarkup}
      {addressMarkup}
    </span>
  );
};

VetNameAndAddress.propTypes = {
  isFullDetailView: PropTypes.bool,
  vetDetail: VetDetailsPropTypes,
  highlightText: PropTypes.string
};
